/* eslint-disable no-underscore-dangle */
import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Actions } from '../../../types/actions.type';
import { Flags } from '../../../types/flags.type';
import { MuComponent } from '../../../types/MuComponent.componetent';

@Component({
  selector: 'app-mu-form-code-sms',
  templateUrl: './mu-form-code-sms.component.html',
  styleUrls: ['./mu-form-code-sms.component.sass'],
})
export class MuFormCodeSmsComponent<ActionType, FlagType> extends MuComponent implements OnInit {
  @Input() formData: UntypedFormGroup;
  @Input() actionList: Actions<ActionType, any>;
  @Input() action: ActionType;
  @Input() flagList: Flags<FlagType>;
  @Input() formInputs: string[];
  @Input() showErrorCode: boolean;
  @Input() countdown: boolean;
  @Input() seconds: number;
  @ViewChildren('formRow') rows: any;

  constructor() {
    super();
  }

  muOnDestroy(): void {
    /** */
  }

  muOnInit(): void {
    /** */
  }

  /**
   * key un event
   * @param {KeyboardEvent} event
   * @param {number} index
   * @returns void
   */
  keyUpEvent(event: KeyboardEvent, index: number): void {
    const value = parseInt(event.key + '', 10);
    index = index + 1;
    if (event.key === 'Backspace') {
      this.rows._results[index - 2]?.nativeElement?.focus();
      return environment.guardClause;
    }
    if (Number.isNaN(value) || value < 0) {
      this.formData?.get(`input${index}`).setValue('', { emitEvent: false });
      return environment.guardClause;
    }
    if (this.rows._results[index]) {
      this.rows._results[index]?.nativeElement?.focus();
    }
  }

  /**
   * emit action button resend code verify
   */
  emitAction(): void {
    this.actionList.emit(this.action, null);
  }
}
